// Exports of the module.
export function toogle(element) {
    const passwordInput = element.parentElement.previousElementSibling;
    const showPath = element.querySelector('path[name="show"]');
    const hidenPath = element.querySelector('path[name="hide"]');
    showPath.classList.toggle('hidden');
    hidenPath.classList.toggle('hidden');
    return passwordInput.type === 'password' ? passwordInput.type = 'text' : passwordInput.type = 'password';
}
